export const QUIZ_QUESTIONS = [
    {
        id: 'energy',
        question: "How is your energy right now?",
        options: [
            { label: "High", value: "high" },
            { label: "Low & Drained", value: "low" },
            { label: "Scattered / Anxious", value: "scattered" },
            { label: "Calm & steady", value: "calm" }
        ]
    },
    {
        id: 'obstacle',
        question: "What is standing in your way?",
        options: [
            { label: "Procrastination", value: "procrastination" },
            { label: "Overthinking", value: "overthinking" },
            { label: "Physical Fatigue", value: "fatigue" },
            { label: "Lack of Direction", value: "direction" }
        ]
    },
    {
        id: 'goal',
        question: "What do you need most?",
        options: [
            { label: "Motivation", value: "motivation" },
            { label: "Inner Peace", value: "peace" },
            { label: "Mental Clarity", value: "clarity" },
            { label: "Discipline", value: "discipline" }
        ]
    },
    {
        id: 'time',
        question: "How much time do you have?",
        options: [
            { label: "5 Minutes", value: "5min" },
            { label: "20 Minutes", value: "20min" },
            { label: "Deep Session (1h+)", value: "1h" }
        ]
    }
];

export const RECOMMENDATIONS = {
    // DEFAULT
    "default": "The obstruction is the path. What is the one thing you are avoiding right now? That is where you must go.",

    // HIGH ENERGY (Manic)
    "high-motivation": "The energy you feel is raw potential. Don't waste it on busywork. Identify the 'Impossible Task'—the one you think you can't do—and write down the first three steps to break it. Today, you are capable of more than you think.",
    "high-peace": "You are vibrating with excess voltage. To find peace, you must discharge it. Go for a walk, run, or move vigorously for 10 minutes. Only when the physical energy is spent will the mental silence return.",
    "high-clarity": "You see everything, which means you see nothing clearly. Radical elimination is required. List your top 5 priorities, then ruthlessly strike out the bottom 4. You are not allowed to touch them until number 1 is complete.",
    "high-discipline": "You are a forged weapon right now. Do not dull your edge on emails or admin. Point yourself at your most complex, demanding problem. Set a timer for 90 minutes and refuse to surface until it is broken.",

    // LOW ENERGY (Drained)
    "low-motivation": "Your battery is empty. Forcing a restart will only drain you further. Lower the bar until we can step over it. What is the smallest, mostly meaningless task you can finish right now to prove to yourself you are still alive?",
    "low-peace": "The world is demanding too much. You have permission to close the shop. Put on headphones, play white noise, and stare at a wall for 15 minutes. You cannot give water from an empty cup.",
    "low-clarity": "You are navigating through fog. Stop moving. Detailed planning now is just guessing. Instead, write down the one thing you are *afraid* is true about your current situation. Naming the fear often clears the mist.",
    "low-discipline": "You are tired. Willpower is expensive; habit is cheap. Do not rely on 'wanting' to do it. Just open the file. Read the last sentence you wrote. Lower the friction so much that starting is easier than stopping.",

    // SCATTERED (Anxious)
    "scattered-motivation": "You are chasing ten rabbits and catching none. Stop running. Pick the one rabbit that actually matters—the task that scares you or bores you the most. Ignore the others. Catch that one, and the rest will follow.",
    "scattered-peace": "Your mind is a storm of uncompleted loops. You cannot 'think' your way to peace. You must somatically ground yourself. Press your feet into the floor. Describe the texture of your shirt. Force your brain back into your body.",
    "scattered-clarity": "Your brain is full of noise. Perform a 'Ram Dump'. Write down every single open loop, worry, and task on a piece of paper. Get it out of your head. Once it is on paper, you represent the master, not the victim.",
    "scattered-discipline": "You are multitasking, which is just a fancy word for procrastinating. Stop. Close all tabs but one. Put your phone in another room. You are not allowed to do anything else until this one specific micro-task is done.",

    // CALM (Steady)
    "calm-motivation": "The water is still, and your boat is ready. Rarity demands utilization. Do not drift. Chart a course for the horizon you've been dreaming of. What is the 'Great Work' you've been putting off? Begin it now.",
    "calm-peace": "This equilibrium is a gift, but it is fragile. Protect it. Do not check your phone. Do not open email. Spend this time in high-quality leisure or reflection. Write a letter to your future self about what matters right now.",
    "calm-clarity": "You have the rare ability to see the bottom of the lake. Look at the foundations of your life. Are they where you want them? Write down one structural change—a habit, a relationship, a job—that needs to happen this year.",
    "calm-discipline": "There is no friction. You flow like water. Use this state for 'Deep Work'. Architect the complex system you usually avoid. Write the difficult code. Plan the novel. You have the bandwidth; use it."
};
